import { createTheme } from "@mui/material";
import { ruRU } from '@mui/material/locale';
import { borderColor, fontSize } from "@mui/system";

let theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1440,
      xl: 1920,
    }
  },

  /**
   * Переопределение компонентов для @core элементов @MUI 
   * использется для тех элементов, в которых не подразумевается переопределение нескольких вариантов стилей как из @presets
   */
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
  },
}, ruRU)

// Настройки типографии
theme = createTheme(theme, {
  typography: {
    fontFamily: "Roboto",
    h1: {
      [theme.breakpoints.up("md")]: {
        fontSize: "3rem",
      },
      [theme.breakpoints.between("xs", "md")]: {
        fontSize: "2.5rem",
      },
      fontWeight: 500,
    },
    h2: {
      [theme.breakpoints.up("md")]: {
        fontSize: "2.5rem",
      },
      [theme.breakpoints.between("xs", "md")]: {
        fontSize: "2rem",
      },
      fontWeight: 500,
    },
    h3: {
      [theme.breakpoints.up("md")]: {
        fontSize: "2rem",
      },
      [theme.breakpoints.between("xs", "md")]: {
        fontSize: "1.5rem",
      },
      fontWeight: 500,
    },
    h4: {
      [theme.breakpoints.up("md")]: {
        fontSize: "1.5rem",
      },
      [theme.breakpoints.between("xs", "md")]: {
        fontSize: "1.25rem",
      },
      fontWeight: 500,
    },
    h5: {
      [theme.breakpoints.up("md")]: {
        fontSize: "1.25rem",
      },
      [theme.breakpoints.between("xs", "md")]: {
        fontSize: "1rem",
      },
      fontWeight: 500,
    },
    h6: {
      [theme.breakpoints.up("md")]: {
        fontSize: "1rem",
      },
      [theme.breakpoints.between("xs", "md")]: {
        fontSize: "0.875rem",
      },
      fontWeight: 500,
    },

    // Кастомная OICO типографика
    B400_18: {
      fontFamily: "Roboto",
      fontSize: "1.125rem",
      fontWeight: 400,
    },
    B700_18: {
      fontFamily: "Roboto",
      fontSize: "1.125rem",
      fontWeight: 700,
    },
    B400_16: {
      fontFamily: "Roboto",
      fontSize: "1rem",
      fontWeight: 400,
    },
    B700_16: {
      fontFamily: "Roboto",
      fontSize: "1rem",
      fontWeight: 700,
    },
    B400_14: {
      fontFamily: "Roboto",
      fontSize: "0.875rem",
      fontWeight: 400,
    },
    B700_14: {
      fontFamily: "Roboto",
      fontSize: "0.875rem",
      fontWeight: 700,
    },
    B400_12: {
      fontFamily: "Roboto",
      fontSize: "0.75rem",
      fontWeight: 400,
    },
    B700_12: {
      fontFamily: "Roboto",
      fontSize: "0.75rem",
      fontWeight: 700,
    },
    B400_10: {
      fontFamily: "Roboto",
      fontSize: "0.625rem",
      fontWeight: 400,
    },
    B700_10: {
      fontFamily: "Roboto",
      fontSize: "0.625rem",
      fontWeight: 700,
    },
  },

  // Настройки цветовой палитры
  palette: {
    black: '#11161C',
    white: '#FFFFFF',
    blue: '#1276E2',
    grey: {
      main: '#AFAFAF',
      dark: '#979797',
      contrastText: '#FFFFFF',
      scale70: '#979797',
      scale50: '#AFAFAF',
      scale20: '#E8E7E7',
      scale10: '#F6F7F9',
    },
    purple: {
      main: '#D5CFE9',
      dark: '#5B4593',
      contrastText: '#FFFFFF',
      scale100: '#5B4593',
      scale50: '#D5CFE9',
      scale20: '#E8E4FA',
      scale10: '#F4F1FF'
    },
    green: {
      main: '#80AB43',
      dark: '#639818',
      contrastText: '#FFFFFF',
      scale100: '#639818',
      scale70: '#80AB43',
      scale50: '#B3DE69',
      scale20: '#F2F7EC'
    },
    yellow: {
      main: '#FBB401',
      contrastText: '#FFFFFF'
    },
    menuBackground: '#F6F7F9',

    // Легаси DS24 цвета (убрать после редизайна)
    secondary: {
      main: '#FB6737',
      contrastText: '#FFFFFF'
    },
    primary: {
      light: '#6A7E94',
      main: '#376495',
      dark: '#2B4D72'
    },
    success: {
      main: '#99BC69',
    },
    error: {
      main: '#EB5757',
    },
    info: {
      main: '#D9DEE2',
      contrastText: '#000000'
    },
    warning: {
      main: '#FBB400'
    },
    text: {
      primary: '#000000',
      secondary: '#697A8B',
      link: '#1276E2',
      textButtonHover: '#2196F3',
    },

    // Новые DS24 и OICO цвета
    OICO: {
      green: '#BBE178',
      red: '#FF9776',
      orange: '#FFB876',
      yellow: '#EFF177',
      blue: '#95C4F6',
      aqua: '#9DDACF',
      purple: {
        main: '#5B4593',
        50: 'oklch(97.7% 0.014 308.299)',
        100: 'oklch(94.6% 0.033 307.174)',
        200: 'oklch(90.2% 0.063 306.703)',
        300: 'oklch(82.7% 0.119 306.383)',
        400: 'oklch(71.4% 0.203 305.504)',
        500: 'oklch(62.7% 0.265 303.9)',
        600: 'oklch(55.8% 0.288 302.321)',
        700: 'oklch(55.8% 0.288 302.321)',
        800: 'oklch(43.8% 0.218 303.724)',
        900: 'oklch(38.1% 0.176 304.987)'
      },
      pink: '#FB8072',
      lightgray: '#f6f7f9',
      crimson: '#e43700',
      neutral: {
        50: 'oklch(0.985 0 0)',
        100: 'oklch(0.97 0 0)',
        200: 'oklch(0.922 0 0)',
        300: 'oklch(0.87 0 0)',
        400: 'oklch(0.708 0 0)',
        500: 'oklch(0.556 0 0)',
        600: 'oklch(0.439 0 0)',
        700: 'oklch(0.371 0 0)',
        800: 'oklch(0.269 0 0)',
        900: 'oklch(0.205 0 0)'
      },
      slate: {
        50:  'oklch(98.4% 0.003 247.858)',
        100: 'oklch(96.8% 0.007 247.896)',
        200: 'oklch(92.9% 0.013 255.508)',
        300: 'oklch(86.9% 0.022 252.894)',
        400: 'oklch(70.4% 0.04 256.788)',
        500: 'oklch(55.4% 0.046 257.417)',
        600: 'oklch(44.6% 0.043 257.281)',
        700: 'oklch(37.2% 0.044 257.287)',
        800: 'oklch(27.9% 0.041 260.031)',
        900: 'oklch(20.8% 0.042 265.755)',
        950: 'oklch(12.9% 0.042 264.695)'
      },
      stone: {
        100: '#F6F7F9',
        200: '#E8E7E7'
      }
    }
  },

  // Настройки UI компонентов
  presets: {
    autocomplete: {
      default: {
        input: {
          '& .MuiOutlinedInput-root': {
            background: theme.palette.menuBackground,
            borderRadius: '10px',
            '&:hover fieldset': {
              borderColor: 'grey.scale70',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'grey.scale70',
            },
            '&.Mui-focused': {
              borderColor: 'grey.scale70',
            },
            '&.Mui-disabled': {
              background: 'grey.scale20',
            },
          },
          '& .MuiInputLabel-root': {
            color: 'grey.scale70',
            '&.Mui-focused': { color: 'grey.scale70', fontWeight: 500 },
          },
          '& .MuiChip-root': {
            height: "24px"
          }
        },
      },
      secondary: {
        input: { 
          '& .MuiOutlinedInput-root': {
            borderRadius: 3,
            color: 'grey.scale70',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',

            '&:hover fieldset': {
              borderColor: 'grey.scale70',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'grey.scale70',
            }
          }       
        },
      },
      white: {
        input: { 
          '& .MuiOutlinedInput-root': {
            borderRadius: 3,
            color: 'black',
            backgroundColor: 'white',

            '&:hover fieldset': {
              borderColor: 'grey.scale70',
            },
            '&.Mui-focused fieldset': {
              borderColor: 'grey.scale70',
            }
          }       
        },
      },
      filled: {
        input: {
          '& .MuiOutlinedInput-root': {
            background: '#EDEFF0',
            borderRadius: '10px',
            padding: '2px',
            fontSize: 14,
            'fieldset': {
              borderColor: '#EDEFF0',
            },
            '&.MuiInputBase-multiline': {
              padding: '12px'
            },
            '&:hover fieldset': {
              borderColor: '#AFAFAF',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#AFAFAF',
            },
            '&.Mui-focused': {
              borderColor: '#AFAFAF',
            },
            '&.Mui-disabled': {
              background: 'grey.scale20',
            },
          },
          '& .MuiInputLabel-root': {
            color: '#EDEFF0',
            '&.Mui-focused': { color: '#EDEFF0', fontWeight: 500 },          
          },
          '& .MuiChip-root': {
            height: "24px"
          },
          '& .MuiInputBase-input::placeholder': {
            color: theme.palette.grey.scale20,
          }
        },
      }
    },
    select: {
      default: {
        select: {         
          '&.MuiOutlinedInput-root': {
            height: '36px',
            borderRadius: 3,
            minWidth: '170px',
            color: 'grey.scale70',
          
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'grey.scale50',
              '&:hover': {
                borderColor: 'grey.scale70',
              },
              '&:focus': {
                borderColor: 'grey.scale70',
              }
            },
          },
        }
      },
      secondary: {
        select: {         
          '&.MuiOutlinedInput-root': {
            height: '36px',
            borderRadius: 3,
            minWidth: '170px',
            color: 'grey.scale70',
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
          
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'grey.scale50',
              '&:hover': {
                borderColor: 'grey.scale70',
              },
              '&:focus': {
                borderColor: 'grey.scale70',
              }
            },
          },
        }
      },
      filled: {
        select: {
        '&.MuiOutlinedInput-root': {
          background: '#EDEFF0',
          borderRadius: '10px',
          padding: '2px',
          fontSize: 14,
          height: '40px',
          
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#EDEFF0',
          },

          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#AFAFAF',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#AFAFAF',
          },
          '&.Mui-disabled': {
            background: 'grey.scale20',
          },
          
          // Стили для иконки стрелки
          '& .MuiSelect-icon': {
            color: 'grey.scale70',
          },
        },
      
        // Стили для выбранного значения
        '& .MuiSelect-select': {
          display: 'flex',
          alignItems: 'center',
          padding: '8px 12px',
        },
        
        // Стили для плейсхолдера
        '& .MuiInputBase-input::placeholder': {
          color: theme.palette.grey.scale20,
        },

    }
  }

    },
    tabs: {
      default: {
        sx: {
          borderBottom: 1,
          borderColor: 'divider',

          '& button': { 
            color: "grey.scale50",
          },
          '& button.Mui-selected': { 
            color: "purple.scale100",
           },

           '& .MuiTabs-indicator': {
            backgroundColor: 'purple.scale100'
           }
        }
      }
    },
    menu: {
      default: {
        sx: {
          '& ul': { padding: '10px' },
          '& li': { padding: 0 },
          '& .MuiMenuItem-root': {
            minWidth: '165px',
            borderRadius: '10px',
            p: '10px 15px',
            transition: 'background-color 0.2s ease-in-out',
            '&:hover': { backgroundColor: '#F4F1FF' },
          },
          "&& .Mui-selected": {
            backgroundColor: 'purple.scale10',
            '&:hover': { backgroundColor: '#F4F1FF' },
          },
        },
        slotProps: {
          paper: {
            style: {
              borderRadius: '20px',
            },
            elevation: 2,
          }
        },
      }
    },
    button: {
      default: {
        secondary: {
          textTransform: 'none',
          padding: '8px 15px',
          [theme.breakpoints.up('md')]: {
            padding: '12px 30px'
          }
        }
      },
      // другие варианты
    }
  },
})

// Алиасы для миксинов
export const styled = (preset, component = preset, variant = 'default', ) => theme.presets[preset][variant][component]

export const autocomplete = (component, variant = 'default') => theme.presets.autocomplete[variant][component];


export default theme;